import { Input } from "@/components/ui/input";
import type { EmailToTaskFormApi } from "@/hooks/useEmailToTaskForm";
import { SectionBlock } from "../SectionBlock";
import { CopyField, Field, ToggleRow } from "./fields";

function formatWhen(iso: string | null) {
	return iso ? new Date(iso).toLocaleString() : "Never";
}

export function GeneralCard({ form, setField, settings, disabled }: EmailToTaskFormApi) {
	return (
		<SectionBlock
			title="Email-to-Task"
			description="Emails sent to the inbound address are parsed by an AI agent into task drafts that a reviewer approves."
		>
			<ToggleRow
				label="Enabled"
				description="When off, incoming emails are stored as ignored and never parsed."
				checked={form.enabled}
				onChange={(v) => setField("enabled", v)}
				disabled={disabled}
			/>
			<div className="mt-3 grid gap-4 sm:grid-cols-2">
				<Field label="Inbound address" htmlFor="ett-inbound" hint="Only emails sent (to, cc or bcc) to this address are accepted.">
					<Input
						id="ett-inbound"
						type="email"
						value={form.inbound_address}
						onChange={(e) => setField("inbound_address", e.target.value)}
						disabled={disabled}
					/>
				</Field>
				<Field label="Webhook URL" htmlFor="ett-webhook" hint="Paste into Resend > Webhooks, event email.received.">
					<CopyField id="ett-webhook" value={settings.webhook_url} />
				</Field>
			</div>
			<dl className="mt-5 grid gap-3 border-t border-border pt-4 text-sm sm:grid-cols-3">
				<div>
					<dt className="text-xs text-muted">Last email received</dt>
					<dd className="text-foreground">{formatWhen(settings.last_webhook_at)}</dd>
				</div>
				<div>
					<dt className="text-xs text-muted">Last processed</dt>
					<dd className="text-foreground">{formatWhen(settings.last_processed_at)}</dd>
				</div>
				<div className="min-w-0">
					<dt className="text-xs text-muted">Last error</dt>
					<dd className={settings.last_error ? "text-danger break-words" : "text-foreground"}>
						{settings.last_error ?? "None"}
					</dd>
				</div>
			</dl>
		</SectionBlock>
	);
}
